import Type from "@/model/types/Type";

const type = {
    FIELD: 1,
    OPERATION_STATUS: 2,
    TOLERANCE: 3,
}

const list = [
    {
        value: type.FIELD,
        text: "Critérios por Campos",
    },
    {
        value: type.OPERATION_STATUS,
        text: "Comparação de Status Operacional",
    },
    {
        value: type.TOLERANCE,
        text: "Tolerância",
    },

]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}